<template>
    <div class="system-tile">
        <div class="system-title">
            <h3 :class="system.name.length > 13 ? 'large-system-title' : ''"> {{system.name}} </h3>
        </div>
        <div class="system-info-amount">
            Games: {{system.amountOfGames}}
        </div>
        <div class="system-info-published">
            {{ system.publisherName }}, {{system.publishedYear}}
        </div>
        <el-image
                :src="system.route ? system.img : system.imgDisabled"
                :class="'system-image'"
                @click="handler(system)"
                @load="onImgLoad"
        ></el-image>

        <background v-show="imageLoaded" :desktop="'system-tile'" :tablet="'system-tile'" :mobile="'system-tile'"></background>
    </div>
</template>

<script>
import Background from '@/components/background.vue'

export default {
  name: 'SystemTile',
  components: { Background },
  props: [ 'system', 'handler' ],
  mounted () {},
  data () {
    return {
      imageLoaded: false
    }
  },

  methods: {
    onImgLoad () {
      this.imageLoaded = true
    }
  }
}
</script>

<style lang="scss">
@import '../styles/variables.scss';

.system-tile {
    .system-title {
        height: 56px;
        text-align: center;
    }

    h3.large-system-title {
        font-size: $font-size-regular;
        line-height: $font-size-regular;
    }

    .system-image {
        margin-top: -50px;
        max-width: 150px;
    }

    .system-info-published {
        margin-top: -30px;
        height: 36px;
        font-size: $font-size-small-regular;
        padding: 5px;
    }

    .system-info-amount {
        margin-top: -20px;
        height: 36px;
        font-size: $font-size-small-regular;
        padding: 5px;
        text-shadow: #0001ff 1px 0 10px;
    }
}
</style>
